import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../../../apps/gs-2.0/src/environments/environment';

export interface UnableToProceedData {}

@Component({
  selector: 'app-unable-to-proceed-dialog',
  standalone: false,
  templateUrl: './unable-to-proceed-dialog.component.html',
  styleUrl: './unable-to-proceed-dialog.component.scss',
})
export class UnableToProceedDialogComponent {
  contactUrl: string;

  constructor(
    private dialogRef: MatDialogRef<UnableToProceedDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: UnableToProceedData
  ) {
    this.contactUrl = environment.fund.contact || '';
  }

  /**
   * Handles continue as guest button click
   */
  onContinueAsGuest(): void {
    this.dialogRef.close({ action: 'guest' });
  }

  /**
   * Handles close button click
   */
  onClose(): void {
    this.dialogRef.close({ action: 'close' });
  }
}
